type Props = {
  size: number;
  strokeColor?: string;
};

const Door = ({ size, strokeColor }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.25 1.5C18.9404 1.5 19.5 2.08763 19.5 2.8125V21.1875C19.5 21.9124 18.9404 22.5 18.25 22.5H5.75C5.05964 22.5 4.5 21.9124 4.5 21.1875V2.8125C4.5 2.08763 5.05964 1.5 5.75 1.5H18.25ZM6 21H18V3H6V21ZM15.5996 10.7998C16.2624 10.7998 16.7998 11.3373 16.7998 12C16.7998 12.6627 16.2623 13.2002 15.5996 13.2002C14.937 13.2 14.4004 12.6626 14.4004 12C14.4004 11.3374 14.937 10.8 15.5996 10.7998Z"
        fill={strokeColor || '#868686'}
      />
    </svg>
  );
};

export default Door;
